import React, { useEffect, useRef, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./notification.css";
import { chatmessages, chats, globalNotification, ownerNotification, profile } from "../../../components/Apis";
import axiosInstance from "../../../axiosConfig/instance";
import {
    Box,
    Card,
    CardContent,
    Typography,
    TextField,
    InputAdornment,
    IconButton,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
    Paper,
} from '@mui/material';

const Notification = () => {
    const [data, setData] = useState(null);
    const token = localStorage.getItem("token") || ""; // Get token from localStorage
    console.log("Notification data", data)

    // useEffect(()=>{

    // },[data])

    const [loading, setLoading] = useState(false);

    const fetchData1 = async () => {
        try {
            const response = await globalNotification();
            console.log("API Response:", response);
            setData(response.data || []); // Ensure `data` is an array
        } catch (error) {
            console.error("API Error:", error);
            setData([]); // Prevent errors if API fails
        }
    };
    const fetchData2 = async () => {
        try {
            const response = await ownerNotification();
            console.log("API Response:", response);
            setData(response.data || []);
        } catch (error) {
            console.error("API Error:", error);
            setData([]);
        }
    };

    return (
        <div className="" style={{ height: "100vh", backgroundColor: "var(--seco-col)" }}>
            <div className="row flex justify-content-center" dir="ltr">

                {/* Sidebar */}
                <div className={`col-md-3 p-3 d-block bg-white`}>
                    <ul className="list-unstyled p-3 rounded">
                        <h4 style={{ borderBottom: "1px solid #ddd", paddingBottom: "10px" }}>Notification</h4>
                        <li className="mb-3 mt-4">
                            <Button
                                variant="outlined"
                                onClick={fetchData1}
                                sx={{
                                    width: "100%",
                                    color: '#fff',
                                    backgroundColor: 'var(--pri-col)',
                                    borderColor: 'var(--pri-col)',
                                    textTransform: 'none',
                                    '&:hover': { backgroundColor: 'var(--pri-col)', borderColor: 'var(--pri-col)' },
                                }}
                            >
                                Global
                            </Button>
                        </li>
                        <li className="mb-3 mt-4">
                            <Button
                                variant="outlined"
                                onClick={fetchData2}
                                sx={{
                                    width: "100%",
                                    color: '#fff',
                                    backgroundColor: 'var(--pri-col)',
                                    borderColor: 'var(--pri-col)',
                                    textTransform: 'none',
                                    '&:hover': { backgroundColor: 'var(--pri-col)', borderColor: 'var(--pri-col)' },
                                }}
                            >
                                Owner
                            </Button>
                        </li>
                    </ul>
                </div>

                {/* Chat Area */}

                <div className="notification_areai col-md-6 p-3">
                    <div className="chat-box bg-white p-3 rounded">
                        <div className="chat-header">
                            <h4 style={{ borderBottom: "1px solid #ddd", paddingBottom: "10px" }}>
                                {data?.length > 0
                                    ? [...new Set(data.map((ele) => ele.type.toUpperCase()))].join(",  ")
                                    : "No Notification Selected"}
                            </h4>                        
                            </div>
                        {data ? data.map((msg) => (
                            // <p>{msg.message}</p>
                            <Message key={msg.id} title={msg.title} body={msg.body} time={msg.created_at} />
                        )) : "No Notification Found"}
                    </div>
                    {/* Message Input Box */}
                </div>
            </div>
        </div>
    );
};

const Message = ({ title, body, time }) => {
    return (
        <div className={`message mb-2`}>
            <div
                className={`message-text p-2 rounded text-start"
          }`}
                style={{ backgroundColor: "#DFEEF4" }}
            >
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <p style={{ border: "0.5ps solid black" }}>{title}</p>
                    <p>{body}</p>
                    <span style={{ width: "100%", color: "gray", fontSize: "10px", textAlign: "end" }}>{time}</span>
                </div>
                {/* <p>{message.message}<span style={{color:"gray"}}>{message.timestamp}</span></p> */}
                {/* <small className={`text-muted ${message.sender === "user" ? "text-black-50" : "text-muted"}`}>
          {message.time}
        </small> */}
            </div>
        </div>
    );
};

export default Notification;
